import { AdvertisingBanner as AuthAdvertisingBanner } from '@sravni/react-silent-authentication-form';
import type { ComponentProps, FC } from 'react';

import styles from './AdvertisingBanner.module.scss';

export const AdvertisingBanner: FC<ComponentProps<typeof AuthAdvertisingBanner>> = (props) => {
  return (
    <AuthAdvertisingBanner
      className={styles.authAdvertisingBanner}
      {...props}
    />
  );
};
